module.exports = __webpack_public_path__ + "img/doorLogo13.0f892e90.png";